import DeliveryWindowModal from 'components/FrictionlessCheckout/SddSection/DeliveryWindow/DeliveryWindowModal/DeliveryWindowModal';

export default DeliveryWindowModal;
